import React from "react";
import SelectSearch from "react-select-search";
import Switch from "react-switch";
import CurrencyInput from "react-currency-input-field";
import DatePicker from "react-datepicker";
import { sl } from "date-fns/locale";
import "react-datepicker/dist/react-datepicker.css";

/*React-bootstrap components */
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import Form from "react-bootstrap/Form";
import Button from "react-bootstrap/Button";

const DeminimisDetailsForm = ({
  detailData,
  isLoading,
  loadError,
  onBack,
  canEdit,
  isEditing,
  onStartEdit,
  onCancelEdit,
  onSubmit,
  isSubmitting,
  submitError,
  submitSuccess,
  deminimisData,
  pomocOdobrena,
  onFieldChange,
  onPomocOdobrenaChange,
  onSelectPrejemnik,
  onSelectDajalec,
  onSelectProjekt,
  onNacrtovanaVrednostChange,
  onVisinaPomociChange,
  prejemnikDefaultOptions,
  dajalecDefaultOptions,
  isPrejemnikLocked,
  defaultOptions,
  fetchPrejemnikOptions,
  fetchDajalecOptions,
  fetchProjektOptions,
}) => {
  const formatDate = (dateValue) => {
    if (!dateValue) {
      return "-";
    }

    const parsedDate = new Date(dateValue);
    if (Number.isNaN(parsedDate.getTime())) {
      return "-";
    }

    return parsedDate.toISOString().slice(0, 10);
  };

  return (
    <>
      <Row className="mb-3">
        <Col>
          <Button
            variant="outline-primary"
            className="programs-button-add-text"
            onClick={onBack}
          >
            Nazaj na pregled
          </Button>
          {!isLoading && !loadError && detailData && !isEditing && canEdit && (
            <Button
              variant="outline-primary"
              className="programs-button-add-text ms-2"
              onClick={onStartEdit}
            >
              Uredi
            </Button>
          )}
          {!isLoading && !loadError && detailData && isEditing && (
            <Button
              variant="outline-secondary"
              className="programs-button-add-text ms-2"
              onClick={onCancelEdit}
              disabled={isSubmitting}
            >
              Prekliči
            </Button>
          )}
        </Col>
      </Row>

      {isLoading && (
        <Row>
          <Col>
            <div>Nalaganje podrobnosti...</div>
          </Col>
        </Row>
      )}

      {!isLoading && loadError && (
        <Row>
          <Col>
            <div className="text-danger">{loadError}</div>
          </Col>
        </Row>
      )}

      {!isLoading && !loadError && detailData && (
        <Form className="deminimis-form" onSubmit={onSubmit}>
          {submitError && (
            <Row>
              <Col>
                <div className="text-danger mb-3">{submitError}</div>
              </Col>
            </Row>
          )}
          {submitSuccess && (
            <Row>
              <Col>
                <div className="text-success mb-3">{submitSuccess}</div>
              </Col>
            </Row>
          )}

          <Form.Group className="mb-3" controlId="deminimisDetailPrejemnik">
            <Form.Label>Prejemnik pomoči</Form.Label>
            {isEditing ? (
              <SelectSearch
                key={`prejemnik-${deminimisData.prejemnikID || "none"}-${prejemnikDefaultOptions.length}`}
                options={prejemnikDefaultOptions}
                getOptions={fetchPrejemnikOptions}
                name="prejemnikID"
                search
                debounce={300}
                placeholder="Vnesite iskalni niz"
                emptyMessage="Ni zadetkov"
                value={deminimisData.prejemnikID}
                onChange={onSelectPrejemnik}
                disabled={isPrejemnikLocked}
                autoComplete="off"
              />
            ) : (
              <Form.Control value={detailData.prejemnik || "-"} readOnly disabled />
            )}
          </Form.Group>

          <Form.Group className="mb-3" controlId="deminimisDetailDajalec">
            <Form.Label>Dajalec pomoči</Form.Label>
            {isEditing ? (
              <SelectSearch
                options={dajalecDefaultOptions}
                getOptions={fetchDajalecOptions}
                name="dajalecID"
                search
                debounce={300}
                placeholder="Vnesite iskalni niz"
                emptyMessage="Ni zadetkov"
                value={deminimisData.dajalecID}
                onChange={onSelectDajalec}
                autoComplete="off"
              />
            ) : (
              <Form.Control value={detailData.dajalec || "-"} readOnly disabled />
            )}
          </Form.Group>

          <Form.Group className="mb-3" controlId="deminimisDetailProjekt">
            <Form.Label>Projekt</Form.Label>
            {isEditing ? (
              <SelectSearch
                key={`projekt-${deminimisData.prejemnikID || 'none'}`}
                options={defaultOptions}
                getOptions={fetchProjektOptions}
                name={`projektID-${deminimisData.prejemnikID || 'none'}`}
                search
                debounce={300}
                placeholder="Vnesite iskalni niz"
                emptyMessage="Ni zadetkov"
                value={deminimisData.projektID}
                onChange={onSelectProjekt}
                autoComplete="new-password"
              />
            ) : (
              <Form.Control value={detailData.projekt || "-"} readOnly disabled />
            )}
          </Form.Group>

          <Form.Group className="mb-3" controlId="deminimisDetailDatumNacrtovanePomoci">
            <Form.Label>Datum načrtovane vrednosti pomoči</Form.Label>
            <DatePicker
              selected={deminimisData.datumNacrtovanePomoci || detailData.datumNacrtovanePomoci ? new Date(deminimisData.datumNacrtovanePomoci || detailData.datumNacrtovanePomoci) : null}
              onChange={(date) => {
                if (isEditing) {
                  onFieldChange({
                    target: {
                      name: "datumNacrtovanePomoci",
                      value: date ? date.toISOString().slice(0, 10) : ""
                    }
                  });
                }
              }}
              dateFormat="dd. MM. yyyy"
              locale={sl}
              className="form-control"
              placeholderText="dd. mm. yyyy"
              showYearDropdown
              showMonthDropdown
              dropdownMode="select"
              readOnly={!isEditing}
              disabled={!isEditing}
            />
          </Form.Group>

          <Form.Group className="mb-3" controlId="deminimisDetailNacrtovanaVrednost">
            <Form.Label>Načrtovana vrednost pomoči</Form.Label>
            <CurrencyInput
              className="form-control"
              placeholder="Vnesite znesek"
              decimalScale={2}
              groupSeparator="."
              decimalSeparator=","
              intlConfig={{ locale: "sl-SI", currency: "EUR" }}
              value={deminimisData.nacrtovanaVrednost}
              onValueChange={onNacrtovanaVrednostChange}
              disabled={!isEditing}
            />
          </Form.Group>

          {isEditing ? (
            <Row className="align-items-center mt-4 mb-3">
              <Col xs="auto">
                <Form.Label className="mb-0">Pomoč je bila odobrena</Form.Label>
              </Col>
              <Col>
                <Switch
                  onChange={onPomocOdobrenaChange}
                  checked={pomocOdobrena}
                  className="ms-1"
                  disabled={!isEditing}
                />
              </Col>
            </Row>
          ) : (
            <Row className="mb-3">
              <Col>
                <strong>Pomoč je bila odobrena: {pomocOdobrena ? "DA" : "NE"}</strong>
              </Col>
            </Row>
          )}

          {pomocOdobrena && (
            <>
              <Row>
                <Col lg={6} className="mb-3">
                  <Form.Group controlId="deminimisDetailDatumOdobritve">
                    <Form.Label>Datum odobritve pomoči</Form.Label>
                    <DatePicker
                      selected={deminimisData.datumOdobritve || detailData.datumOdobritve ? new Date(deminimisData.datumOdobritve || detailData.datumOdobritve) : null}
                      onChange={(date) => {
                        if (isEditing) {
                          onFieldChange({
                            target: {
                              name: "datumOdobritve",
                              value: date ? date.toISOString().slice(0, 10) : ""
                            }
                          });
                        }
                      }}
                      dateFormat="dd. MM. yyyy"
                      locale={sl}
                      className="form-control"
                      placeholderText="dd. mm. yyyy"
                      showYearDropdown
                      showMonthDropdown
                      dropdownMode="select"
                      readOnly={!isEditing}
                      disabled={!isEditing}
                    />
                  </Form.Group>
                </Col>
                <Col lg={6} className="mb-3">
                  <Form.Group controlId="deminimisDetailVisinaPomoci">
                    <Form.Label>Višina odobrene pomoči</Form.Label>
                    <CurrencyInput
                      className="form-control"
                      placeholder="Vnesite znesek"
                      decimalScale={2}
                      groupSeparator="."
                      decimalSeparator=","
                      intlConfig={{ locale: "sl-SI", currency: "EUR" }}
                      value={deminimisData.visinaPomoci}
                      onValueChange={onVisinaPomociChange}
                      disabled={!isEditing}
                    />
                  </Form.Group>
                </Col>
              </Row>

              <Form.Group className="mb-3" controlId="deminimisDetailPravnaPodlaga">
                <Form.Label>Pravna podlaga</Form.Label>
                <Form.Control
                  name="pravnaPodlaga"
                  as="textarea"
                  rows={3}
                  maxLength={500}
                  placeholder="Vnesite tekst, omejitev 500 znakov"
                  value={deminimisData.pravnaPodlaga}
                  onChange={onFieldChange}
                  readOnly={!isEditing}
                  disabled={!isEditing}
                />
              </Form.Group>

              <Form.Group className="mb-3" controlId="deminimisDetailStevilkaPriglasitve">
                <Form.Label>Številka priglasitve</Form.Label>
                <Form.Control
                  name="stevilkaPriglasitve"
                  type="text"
                  placeholder="Vnesite številko priglasitve"
                  value={deminimisData.stevilkaPriglasitve}
                  onChange={onFieldChange}
                  readOnly={!isEditing}
                  disabled={!isEditing}
                />
              </Form.Group>
            </>
          )}

          {isEditing && (
            <Row>
              <Col>
                <Button
                  variant="outline-primary"
                  type="submit"
                  className="programs-button-add-text"
                  disabled={isSubmitting}
                >
                  {isSubmitting ? "Shranjujem..." : "Shrani"}
                </Button>
              </Col>
            </Row>
          )}

        </Form>
      )}
    </>
  );
};

export default DeminimisDetailsForm;
